import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = loc.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login", { replace: true });
      return;
    }
    const sid = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        await refresh();
        const dest = data?.onboarding_pending ? "/app" : "/app/executive";
        window.history.replaceState({}, "", dest);
        nav(dest, { replace: true });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="pc-card px-8 py-6 flex items-center gap-3">
        <div className="w-5 h-5 border-2 border-blue-400 border-t-transparent rounded-full animate-spin"></div>
        <span className="text-slate-200">Signing you in…</span>
      </div>
    </div>
  );
}
